// src/features/services/media-v2/components/MediaDashboard.tsx
// ─────────────────────────────────────────────────────────────────────────────
// Media V2 — zero-prop top-level dashboard.
// Owns no state from App.tsx; delegates to YouTubeIngestPanel,
// AudioLibrary, and MusicProjects sub-components.
// PAC Glass design system.
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState } from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import YouTubeIngestPanel from './YouTubeIngestPanel';
import AudioLibrary from './AudioLibrary';
import MusicProjects from './MusicProjects';

type Tab = 'youtube' | 'library' | 'projects';

export default function MediaDashboard() {
  useDocumentTitle('Media');
  const [tab, setTab] = useState<Tab>('youtube');

  return (
    <section className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-neutral-100">Media</h1>
        <span className="text-[10px] text-neutral-600 uppercase tracking-wider">
          Audio &amp; Music Production
        </span>
      </div>

      {/* Tab bar */}
      <div className="flex gap-1 border-b border-neutral-800 pb-px">
        {(['youtube', 'library', 'projects'] as Tab[]).map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`px-3 py-1.5 text-xs font-medium rounded-t transition-colors
              ${tab === t
                ? 'bg-neutral-800 text-neutral-100 border-b-2 border-cyan-500'
                : 'text-neutral-500 hover:text-neutral-300'
              }`}
          >
            {t === 'youtube' ? 'YouTube Ingest' : t === 'library' ? 'Audio Library' : 'Music Projects'}
          </button>
        ))}
      </div>

      {tab === 'youtube'  && <YouTubeIngestPanel />}
      {tab === 'library'  && <AudioLibrary />}
      {tab === 'projects' && <MusicProjects />}
    </section>
  );
}
